<template>
  <div class="hello">
    <template v-if="Object.keys(oneData).length">
      <div class="list-box">

        <div class="bg_img">
          <img src="../assets/bg_pro.png" alt="">
        </div>
        <div :class="['leaderboard-card', 'leaderboard-card-change']">
          <div class="fullscreen-btn" @click="toScreenfull">
            <i :class="['fas', isScreenfull ? 'fa-compress' : 'fa-expand']"></i>
          </div>

          <div :class="['card-header', `card-header${headerCol}`]">
            <div class="card-title">
              <i class="fas fa-chart-line"></i>
              <span>
                {{ `${hanldValue(oneData, 'platform_info.name', '')}${salaMap[hanldValue(oneData, 'bannerType',
                  'err')]}`
                }}
              </span>
            </div>
          </div>

          <div class="leaderboard-list">
            <template v-if="hanldValue(oneData, 'platform_sale_rank_data', []).length">
              <div class="leaderboard-item" v-for="(item, ind) in oneData.platform_sale_rank_data" :key="item.user_id">
                <div :class="['rank', `rank-${ind + 1}`]">{{ ind + 1 }}</div>
                <div class="avatar-container">
                  <div class="avatar">
                    <img :src="hanldValue(item, 'user_info.avatar_url_abs') || getAvatarPlaceholder()" alt="">
                  </div>
                  <div class="user-name">{{ hanldValue(item, 'user_info.name') }}</div>
                </div>
                <div class="user-info">
                  <div class="data-stats-container">
                    <div class="stat-item">
                      <div class="stat-label">{{ hanldValue(oneData, 'beforeYesterday') }}</div>
                      <div class="stat-value">
                        {{ hanldMonely(item.day_before_yesterday_sale_data, oneData.rank_config.method_type) }}
                      </div>
                    </div>
                    <div class="stat-item">
                      <div class="stat-label">{{ hanldValue(oneData, 'yesterday') }}</div>
                      <div class="stat-value medium-low">
                        {{ hanldMonely(item.yesterday_data, oneData.rank_config.method_type) }}
                      </div>
                    </div>
                    <div class="stat-item average-item">
                      <div class="stat-label">{{ hanldTitle(oneData.bannerType, oneData.rank_config.method_type) }}
                      </div>
                      <div class="stat-value">{{ hanldMonely(item.total_data, oneData.rank_config.method_type) }}</div>
                    </div>
                    <div class="stat-item" v-if="sala_type === 'after'">
                      <div class="stat-label">{{ '激励金额' }}</div>
                      <div class="stat-value medium-low">
                        {{ hanldValue(item, "reward_money") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="empty-message" v-else>
              <i class="fas fa-database"></i>
              暂无数据
            </div>
          </div>

          <div class="card-footer">
            <div class="update-time">{{ `更新时间：${uploadTime}` }}</div>
          </div>
        </div>
      </div>
    </template>
    <div id="loading" class="loading" v-else>
      <i class="fas fa-spinner fa-spin"></i> 正在加载数据...

    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import screenfull from 'screenfull'
import { afterSaleRank, beforeSaleRank } from "@/api/rank";


export default {
  props: {
    sala_type: String,
    platform_id: String,
  },
  data() {
    return {
      isScreenfull: false,
      uploadTime: dayjs().format("HH:mm:ss"),
      changeBanner: 0,
      currCountdown: 10,
      setTime: 10,
      countdownTimer: null,
      salaMap: {
        'sale_before': '售前',
        'sale_after': '售后',
        'err': ''
      },
      headerCol: 0,
      oneData: {}
    }
  },
  created() {
  },
  mounted() {
    this.init();
    this.getCurrData()
  },
  watch: {
    sala_type: {
      handler(newValue) {
        console.log('newValue', newValue)

        setTimeout(() => {
          this.getCurrData()
        }, 0)
      },
      immediate: true // 在实例化时立即执行
    },
  },
  methods: {
    init() {
      if (screenfull.isEnabled) {
        this.isScreenfull = false;
        screenfull.on('change', this.change)
      }
    },

    getCurrData() {
      this.headerCol = Math.floor(Math.random() * 4)
      if (this.sala_type === 'after') {
        afterSaleRank({ platform_id: this.platform_id }).then(res => {
          console.log('售后数据', res)
          if (res.code === 20000) {
            this.oneData = {
              ...res.data,
              bannerType: 'sale_after',
              yesterday: dayjs().subtract(1, 'day').format('MM-DD'),
              beforeYesterday: dayjs().subtract(2, 'day').format('MM-DD')
            }
          }
        })
      } else {
        beforeSaleRank({ platform_id: this.platform_id }).then(res => {
          console.log('售前数据', res)
          if (res.code === 20000) {
            this.oneData = {
              ...res.data,
              bannerType: 'sale_before',
              yesterday: dayjs().subtract(1, 'day').format('MM-DD'),
              beforeYesterday: dayjs().subtract(2, 'day').format('MM-DD')
            }
          }
        })
      }

    },

    hanldValue(obj, path, result = null) {
      if (obj === null || obj === undefined || obj === '') return result
      for (const e of path.split('.')) {
        obj = obj[e]
        if (obj == null || obj === '' || obj.length === 0) return result
      }
      return obj
    },

    hanldTitle(sala, type) {
      if (sala === 'sale_before') {
        return type === 1 ? '转化率' : '销售金额'
      } else if (sala === 'sale_after') {
        return type === 1 ? '挽单量' : '挽单金额'
      }
      return ''
    },

    hanldMonely(numScore, unit) {
      // console.log('hanldMonely ', numScore, unit)
      if (unit === 1) {
        return numScore
      } else {
        let numSala = Number(numScore)
        if (numSala >= 10000) {
          return (numSala / 10000).toFixed(1) + '万';
        } else if (numSala >= 1000) {
          return (numSala / 1000).toFixed(1) + '千';
        } else if (numSala % 1 === 0) {
          return numSala.toString();
        } else if (numSala < 10) {
          return numSala.toFixed(1);
        } else {
          return Math.round(numSala).toString();
        }
      }
    },

    change() {
      if (screenfull.isFullscreen) {
        this.isScreenfull = true;
      } else {
        this.isScreenfull = false
      }
    },

    // 头像加载失败时的占位符
    getAvatarPlaceholder() {
      return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNDAiIGZpbGw9IiMyNzMzNDgiLz48cGF0aCBkPSJNNjUgNjVINDM1MzVRNTEgNjUgNTUgNjJUNjAgNTdWNDJRNjAgMzYgNTYgMzJUNCAyOEg0Mk00MyAzNUg1N1E2MyAzNSA2NyAzOVQ3MiA0MlE3MiA0OCA2OCA1MlQ1NyA1Nkg0M1EzNyA1NiAzMyA1MlQyOSA0MlEyOSAzNSAzMyAzMVQ0MyAyNyIgb3BhY2l0eT0iMC42IiBmaWxsPSIjZmZmIi8+PC9zdmc+';
    },

    toScreenfull() {
      if (!screenfull.isEnabled) {
        return false
      }
      screenfull.toggle();
    },

  }
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Hiragino Sans GB', sans-serif;
}

.hello {
  background: linear-gradient(135deg, #0a0e29 0%, #1a1f4b 100%);
  color: #fff;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .loading {
    text-align: center;
    font-size: 4rem;
    padding: 80px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .list-box {
    height: 100vh;
    width: 100vw;
    position: relative;

    .bg_img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  /* 排行榜卡片 - 全屏占据全部空间 */
  .leaderboard-card {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 0;
    overflow: hidden;
    border: none;
    transition: all 0.3s ease;
    // backdrop-filter: blur(25px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 35px 70px rgba(0, 0, 0, 0.4);
    height: 100vh;
    width: 100vw;
    box-sizing: border-box;
  }

  .leaderboard-card-change {
    animation: fadeIn 0.8s ease-out;
  }

  .hide {
    display: none !important;
  }

  /* 不同分类的卡片样式 */
  .tm-sales-card .card-header {
    background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
  }

  .tm-after-sales-card .card-header {
    background: linear-gradient(90deg, #45b7d1, #67d9f2);
  }

  .jd-sales-card .card-header {
    background: linear-gradient(90deg, #ff9f43, #ffbe76);
  }

  .jd-after-sales-card .card-header {
    background: linear-gradient(90deg, #96ceb4, #b8e6d0);
  }

  .card-header {
    padding: 40px 50px;
    text-align: center;
    border-bottom: 8px solid rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    z-index: 1;
  }

  .card-header0 {
    background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
  }

  .card-header1 {
    background: linear-gradient(90deg, #45b7d1, #67d9f2);
  }

  .card-header2 {
    background: linear-gradient(90deg, #ff9f43, #ffbe76);
  }

  .card-header3 {
    background: linear-gradient(90deg, #96ceb4, #b8e6d0);
  }

  .card-title {
    font-size: 6rem;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    letter-spacing: 3px;
    text-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
    // background: #da0707;
  }

  .card-title i {
    font-size: 6.5rem;
  }

  .leaderboard-list {
    flex: 1;
    padding: 20px 0;
    height: auto;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    /* 确保不使用弹性收缩，否则无法触发 scrollTop 滚动 */
    justify-content: flex-start;
    /* 必须设置为 auto，平滑滚动(smooth)会干扰定时器的精准度 */
    scroll-behavior: auto !important;
  }

  /* 隐藏滚动条让视觉更干净（可选） */
  .leaderboard-list::-webkit-scrollbar {
    display: none;
  }

  .leaderboard-list::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 20px;
  }

  .leaderboard-list::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 20px;
    border: 5px solid rgba(0, 0, 0, 0.1);
  }

  .leaderboard-item {
    display: flex;
    align-items: center;
    padding: 30px 40px;
    border-bottom: 4px solid rgba(255, 255, 255, 0.08);
    transition: all 0.3s ease;
    min-height: 240px;
    position: relative;
    margin: 10px 40px;
    border-radius: 25px;
    background: rgba(255, 255, 255, 0.2);
  }

  .leaderboard-item:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-3px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
  }

  .rank {
    font-size: 5.5rem;
    font-weight: 900;
    width: 160px;
    text-align: center;
    flex-shrink: 0;
    text-shadow: 3px 3px 12px rgba(0, 0, 0, 0.5);
    padding: 35px 0;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 25px;
    margin-right: 30px;
  }

  .rank-1 {
    color: #ffd700;
    text-shadow: 0 0 35px rgba(255, 215, 0, 0.7);
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.2));
    border: 5px solid rgba(255, 215, 0, 0.3);
  }

  .rank-2 {
    color: #c0c0c0;
    text-shadow: 0 0 30px rgba(192, 192, 192, 0.5);
    background: linear-gradient(135deg, rgba(192, 192, 192, 0.1), rgba(192, 192, 192, 0.2));
    border: 5px solid rgba(192, 192, 192, 0.3);
  }

  .rank-3 {
    color: #cd7f32;
    text-shadow: 0 0 30px rgba(205, 127, 50, 0.5);
    background: linear-gradient(135deg, rgba(205, 127, 50, 0.1), rgba(205, 127, 50, 0.2));
    border: 5px solid rgba(205, 127, 50, 0.3);
  }

  .rank-4 {
    color: #4ecdc4;
    text-shadow: 0 0 25px rgba(78, 205, 196, 0.4);
    background: linear-gradient(135deg, rgba(78, 205, 196, 0.1), rgba(78, 205, 196, 0.2));
    border: 5px solid rgba(78, 205, 196, 0.3);
  }

  .rank-5 {
    color: #45b7d1;
    text-shadow: 0 0 25px rgba(69, 183, 209, 0.4);
    background: linear-gradient(135deg, rgba(69, 183, 209, 0.1), rgba(69, 183, 209, 0.2));
    border: 5px solid rgba(69, 183, 209, 0.3);
  }

  .avatar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 50px;
    flex-shrink: 0;
    min-width: 220px;
  }

  .avatar {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    overflow: hidden;
    border: 8px solid rgba(255, 255, 255, 0.25);
    margin-bottom: 20px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
  }

  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .user-name {
    font-weight: 900;
    font-size: 3.5rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
    font-family: 'Microsoft YaHei', sans-serif;
    padding: 8px 20px;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    border: 3px solid rgba(255, 255, 255, 0.1);
  }

  .user-info {
    flex: 1;
    min-width: 0;
    margin: 0 35px;
    display: flex;
    align-items: stretch;
  }

  /* 日期统计数据 + 汇总区域 - 三个区域等宽 */
  .data-stats-container {
    flex: 1;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 30px;
  }

  /* 每个区域（前天、昨天、汇总）等宽 - 各占1/3 */
  .stat-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 20px;
    border: 3px solid rgba(255, 255, 255, 0.08);
    min-height: 180px;
    transition: all 0.3s ease;
  }

  /* 汇总/挽单区域特殊样式 */
  .stat-item.average-item {
    background: rgba(255, 255, 255, 0.15);
    border: 4px solid rgba(255, 255, 255, 0.25);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2), 0 0 20px rgba(255, 255, 255, 0.1);
  }

  .stat-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  }

  .stat-label {
    font-size: 3rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 700;
    margin-bottom: 15px;
    text-align: center;
  }

  /* 汇总/挽单标签特殊样式 */
  .average-item .stat-label {
    color: rgba(255, 255, 255, 0.95);
    font-weight: 900;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  }

  .stat-value {
    font-size: 4.2rem;
    font-weight: 900;
    color: #fff;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    text-align: center;
    //color: #48dbfb;
    text-shadow: 0 0 15px rgba(72, 219, 251, 0.3);
  }

  /* 汇总/挽单数值特殊样式 */
  .average-item .stat-value {
    font-size: 4.8rem;
    text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.6);
  }

  .percentage-value.high {
    color: #ff6b6b;
    text-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
  }

  .percentage-value.medium-high {
    color: #ff9f43;
    text-shadow: 0 0 18px rgba(255, 159, 67, 0.4);
  }

  .percentage-value.medium {
    color: #feca57;
    text-shadow: 0 0 15px rgba(254, 202, 87, 0.3);
  }

  .percentage-value.medium-low {
    //color: #48dbfb;
    text-shadow: 0 0 15px rgba(72, 219, 251, 0.3);
  }

  .percentage-value.low {
    color: #0abde3;
    text-shadow: 0 0 15px rgba(10, 189, 227, 0.3);
  }

  .number-value.high {
    color: #ff6b6b;
    text-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
  }

  .number-value.medium-high {
    color: #ff9f43;
    text-shadow: 0 0 18px rgba(255, 159, 67, 0.4);
  }

  .number-value.medium {
    color: #feca57;
    text-shadow: 0 0 15px rgba(254, 202, 87, 0.3);
  }

  .number-value.medium-low {
    color: #48dbfb;
    text-shadow: 0 0 15px rgba(72, 219, 251, 0.3);
  }

  .number-value.low {
    color: #0abde3;
    text-shadow: 0 0 15px rgba(10, 189, 227, 0.3);
  }

  .card-footer {
    padding: 35px;
    text-align: center;
    border-top: 4px solid rgba(255, 255, 255, 0.15);
    background: rgba(0, 0, 0, 0.3);
    margin-top: auto;
    min-height: 100px;
    z-index: 1;
  }

  .update-time {
    font-size: 2.8rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 900;
    letter-spacing: 2px;
  }

  .empty-message {
    text-align: center;
    padding: 100px 50px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 4rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .empty-message i {
    font-size: 6rem;
    margin-bottom: 40px;
    color: #4ecdc4;
  }

  /* 动画效果 */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(200px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .leaderboard-item {
    animation: fadeIn 0.4s ease-out;
    animation-fill-mode: both;
  }

  .leaderboard-item:nth-child(1) {
    animation-delay: 0.1s;
  }

  .leaderboard-item:nth-child(2) {
    animation-delay: 0.2s;
  }

  .leaderboard-item:nth-child(3) {
    animation-delay: 0.3s;
  }

  .leaderboard-item:nth-child(4) {
    animation-delay: 0.4s;
  }

  .leaderboard-item:nth-child(5) {
    animation-delay: 0.5s;
  }

  /* 分类指示器 */
  .category-indicator {
    position: fixed;
    bottom: 30px;
    right: 60px;
    display: flex;
    gap: 10px;
    z-index: 100;

    .category-dot {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;
    }


    .active {
      background: #4ecdc4;
      transform: scale(1.3);
      box-shadow: 0 0 15px rgba(78, 205, 196, 0.7);
    }
  }


  /* 切换计时器 */
  .timer-indicator {
    position: fixed;
    top: 30px;
    right: 30px;
    background: rgba(0, 0, 0, 0.6);
    padding: 10px 25px;
    border-radius: 10px;
    font-size: 2.5rem;
    font-weight: 700;
    color: #4ecdc4;
    border: 3px solid rgba(78, 205, 196, 0.3);
    z-index: 100;
  }

  /* 全屏按钮 */
  .fullscreen-btn {
    position: fixed;
    top: 30px;
    left: 30px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    border: none;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5rem;
    z-index: 100;
    transition: all 0.3s ease;
  }

  .fullscreen-btn:hover {
    background: rgba(78, 205, 196, 0.8);
    transform: scale(1.1);
    box-shadow: 0 0 20px rgba(78, 205, 196, 0.5);
    border-radius: 50%;
  }

  /* 响应式调整 - 针对超高分辨率 */
  @media (min-height: 1000px) {
    .card-header {
      min-height: 240px;
      padding: 50px;
    }

    .card-title {
      font-size: 7rem;
      gap: 50px;
    }

    .card-title i {
      font-size: 7.5rem;
    }

    .leaderboard-item {
      min-height: 280px;
      padding: 40px 50px;
      margin: 15px 50px;
    }

    .rank {
      font-size: 6rem;
      width: 180px;
      padding: 45px 0;
    }

    .avatar-container {
      min-width: 300px;
      margin: 0 60px;
    }

    .avatar {
      width: 150px;
      height: 150px;
      margin-bottom: 25px;
    }

    .user-name {
      font-size: 3rem;
      max-width: 280px;
    }

    .stat-label {
      font-size: 3.5rem;
    }

    .stat-value {
      font-size: 4.8rem;
    }

    .average-item .stat-value {
      font-size: 5.5rem;
    }

    .update-time {
      font-size: 3.2rem;
    }
  }

  @media (min-height: 1200px) {
    .leaderboard-item {
      min-height: 320px;
    }

    .stat-item {
      min-height: 220px;
    }

    .card-footer {
      padding: 45px;
      min-height: 120px;
    }
  }

  @media (max-width: 1200px) {
    .card-title {
      font-size: 5rem;
      gap: 30px;
    }

    .card-title i {
      font-size: 5.5rem;
    }

    .leaderboard-item {
      min-height: 200px;
      padding: 25px 30px;
      margin: 8px 30px;
    }

    .rank {
      font-size: 4.5rem;
      width: 140px;
      padding: 30px 0;
    }

    .avatar-container {
      min-width: 180px;
      margin: 0 40px;
    }

    .avatar {
      width: 130px;
      height: 130px;
    }

    .user-name {
      font-size: 3.5rem;
      max-width: 200px;
    }

    .data-stats-container {
      gap: 20px;
    }

    .stat-item {
      padding: 20px 15px;
      min-height: 150px;
    }

    .stat-label {
      font-size: 2.5rem;
    }

    .stat-value {
      font-size: 3.5rem;
    }

    .average-item .stat-value {
      font-size: 4rem;
    }

    .update-time {
      font-size: 2.5rem;
    }
  }

  /* 小屏幕适配 */
  @media (max-width: 768px) {
    .card-header {
      padding: 30px 20px;
      min-height: 150px;
    }

    .card-title {
      font-size: 4rem;
      gap: 20px;
    }

    .card-title i {
      font-size: 4.5rem;
    }

    .leaderboard-item {
      flex-direction: column;
      min-height: auto;
      padding: 30px;
      margin: 15px;
    }

    .rank {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
      padding: 20px;
      font-size: 4rem;
    }

    .avatar-container {
      margin: 20px 0;
      min-width: auto;
    }

    .user-info {
      flex-direction: column;
      width: 100%;
      margin: 20px 0 0 0;
    }

    .data-stats-container {
      flex-direction: column;
      gap: 15px;
    }

    .stat-item {
      width: 100%;
    }
  }
}
</style>